/**
 * MIME type からファイル種別を分類するヘルパー。
 * UI 上の表示・プレビュー方式・アイコンを統一的に決めるため、ここに集約する。
 */

export type FileKind = 'video' | 'image' | 'pdf' | 'audio' | 'other'

export function classifyFile(mimeType: string): FileKind {
  if (mimeType.startsWith('video/')) return 'video'
  if (mimeType.startsWith('image/')) return 'image'
  if (mimeType === 'application/pdf') return 'pdf'
  if (mimeType.startsWith('audio/')) return 'audio'
  return 'other'
}

export function iconForKind(kind: FileKind): string {
  switch (kind) {
    case 'video':
      return '🎬'
    case 'image':
      return '🖼'
    case 'pdf':
      return '📄'
    case 'audio':
      return '🎵'
    default:
      return '📁'
  }
}

/**
 * このファイル種別はモーダルで「フルプレビュー」可能か？
 * 動画は VideoPlayer で別経路、画像/PDF は FileViewerModal で表示。
 */
export function isPreviewable(kind: FileKind): boolean {
  return kind === 'image' || kind === 'pdf'
}
